<template>
  <div class="main">
    <report-top>
      <template slot="search">
        <ly-search v-model="searchItem.keyWork" @search="search"></ly-search>
      </template>
    </report-top>
    <div id="formTable">
      <div class="formTableItem">
        <p class="label">时间范围</p>
        <start-end ref="startEnd" timeModel="2,3,0"></start-end>
      </div>

      <div class="formTableItem">
        <p class="label">项目名称</p>
        <div style="width: 120px">
          <selectItems
            :name="searchItem.groupName"
            @update:name="searchItem.groupName = $event"
            :id="searchItem.groupId"
            @update:id="searchItem.groupId = $event"
            clearable
          ></selectItems>
        </div>
      </div>

      <div class="formTableItem">
        <p class="label">所属部门</p>
        <selectGroup
          :name="searchItem.deptName"
          @update:name="searchItem.deptName = $event"
          :id="searchItem.deptId"
          @update:id="searchItem.deptId = $event"
          clearable
        >
        </selectGroup>
      </div>

      <div class="formTableItem">
        <Button @click="chaxun" type="primary" size="small" class="chaxun"
          >立即查询</Button
        >
      </div>
    </div>

    <Table
      border
      :columns="columns"
      :data="tableData"
      no-data-text="<div class='table-no-data'></div>"
      :height="utils.setTableHeight(200)"
    >
      <template slot-scope="{ row, index }" slot="action">
        <Button size="small" @click="open(row)">立即查看</Button>
      </template>
    </Table>
    <div id="mypage" v-if="false">
      <div>
        <Page
          :current="1"
          :total="total"
          :page-size="searchItem.pageSize"
          :page-size-opts="[10, 50, 100]"
          show-total
          show-elevator
          show-sizer
          @on-change="changePage"
          @on-page-size-change="pageSizeChange"
        ></Page>
      </div>
    </div>
    <classWorks ref="classWorks"></classWorks>
  </div>
</template>
<script>
import axios from "axios";
import classWorks from "./classWorks.vue";
export default {
  components: { classWorks },
  data() {
    return {
      columns: [
        {
          type: "index",
          width: 70,
          align: "center",
        },
        {
          title: "作业日期",
          key: "gpsTime",
          render: (h, data) => {
            return h("div", this.utils.time(data.row.jobDate, "yymmdd"));
          },
        },
        {
          title: "车牌号",
          key: "carNo",
        },

        {
          title: "线路名称",
          key: "lineName",
        },
        {
          title: "线路标段",
          key: "lable",
        },
        {
          title: "作业总里程",
          key: "jobMileageReal",
        },
        {
          title: "作业完成率/%",
          key: "finishPercent",
        },
        {
          title: "是否合格",
          key: "isPass",
          render: (h, data) => {
            return h("div", this.$t("isPass." + data.row.isPass));
          },
        },
        {
          title: "操作",
          slot: "action",
        },
      ],
      tableData: [],
      total: 0,
      searchItem: {
        startDate: "",
        carNo: "",
        endDate: "",
        pageNumber: 0,
        pageSize: 0,
        groupId: null,
      },
    };
  },
  methods: {
    getList() {
      console.log(this.searchItem);
      this.utils.loading(this, "加载中");
      axios({
        method: "post",
        url: axios.work + "/carJobReport/carJobReportGroupLine",
        data: this.searchItem,
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        this.total = res.data.data.total;
        var data = res.data.data.dataList;
        console.log(data);
        this.tableData = data;
      });
    },
    changePage(x) {
      this.searchItem.pageNumber = x;
      this.getList();
    },
    //每页总条数切换
    pageSizeChange(x) {
      this.searchItem.pageSize = x;
      this.getList();
    },
    chaxun() {
      this.searchItem.startDate = this.$refs.startEnd.getTimeObj().start;
      this.searchItem.endDate = this.$refs.startEnd.getTimeObj().end;
      this.getList();
    },
    search() {
      console.log(this.keyWork);
      this.reset();
      this.getList();
    },
    reset() {},
    open(row) {
      var a = row;
      a.startDate = this.searchItem.startDate;
      a.endDate = this.searchItem.endDate;
      this.$refs.classWorks.reachData(a);
    },
  },
  mounted() {
    this.chaxun();
  },
};
</script>
<style>
</style>


// WEBPACK FOOTER //
// src/components/work/lineWorks.vue